const serviceTypeDisplay = (type: string) => {
    switch (type) {
        case 'sheets': return 'Service';
        case 'chemAppService': return 'Custom App Service';
        case 'preseason': return 'Pre-Season';
        case 'refrigeration': return 'Refrigeration';
        case 'salesOrders': return 'Sales Order';
        case 'chemappinspections': return 'Custom App Inspection';
        case 'inspections': return 'Inspection';
        case 'freshpack': return 'Fresh Pack';
        case 'chemAppAgreement': return 'Custom App';
        case 'sprayBarAgreement': return 'Spray Bar Service';
        case 'disinfectantAgreement': return 'Disinfectant Service';
        case 'freshPack': return 'Fresh Pack';
        case 'chemAppsInspections': return 'Custom App Inspection';
        default: return 'Service';
    }
};

export default serviceTypeDisplay;
